function findNodeByLabel(doc, expectedKind, label) {
  return (
    Object.values(doc.nodes).find(
      (n) => n.kind === expectedKind && (n.label || "").trim() === label
    ) || null
  );
}

function resolvePickPlaceSetupNodes(doc) {
  if (!doc) return null;
  const rootNode = doc.nodes[doc.rootId];
  if (!rootNode || rootNode.kind !== "sequence") return null;
  const randomizeNode = findNodeByLabel(doc, "randomizeObjectPose", "Randomize target object");
  const pickNode = findNodeByLabel(doc, "moveEeToXyz", "Approach pick point");
  const dropNode = findNodeByLabel(doc, "moveEeToXyz", "Approach drop point");
  const dropDescendNode = findNodeByLabel(doc, "moveEeByOffset", "Descend to place");
  if (!randomizeNode || !pickNode || !dropNode) return null;
  const moveNodes = Object.values(doc.nodes).filter(
    (n) =>
      (n.kind === "moveEeToXyz" || n.kind === "moveEeByOffset") &&
      [
        "Approach pick point",
        "Descend to grasp",
        "Lift object",
        "Approach drop point",
        "Descend to place",
        "Retreat up",
      ].includes((n.label || "").trim())
  );
  const graspGateNodes = Object.values(doc.nodes).filter(
    (n) =>
      n.kind === "conditionObjectGrasped" &&
      ["Gate: Object grasped before carry", "Gate: Object grasped before place"].includes(
        (n.label || "").trim()
      )
  );
  const pickEeGateNodes = Object.values(doc.nodes).filter(
    (n) =>
      n.kind === "conditionEeNear" &&
      ["Gate: EE hovering above pick", "Gate: EE at grasp point"].includes((n.label || "").trim())
  );
  const dropEeGateNodes = Object.values(doc.nodes).filter(
    (n) => n.kind === "conditionEeNear" && (n.label || "").trim() === "Gate: EE hovering above drop"
  );
  return {
    rootNode,
    randomizeNode,
    pickNode,
    dropNode,
    dropDescendNode,
    moveNodes,
    graspGateNodes,
    pickEeGateNodes,
    dropEeGateNodes,
  };
}

export { resolvePickPlaceSetupNodes };
